import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreService } from '../core/core.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router, private core: CoreService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (req.headers.get('No-Auth') === 'True') {
            return next.handle(req.clone());
      }
        if (localStorage.getItem('appToken') != null) {

            const clonedreq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('appToken'))
            });

            return next.handle(clonedreq)
            .pipe(
              tap(
                (event: HttpEvent<any>) => {
                  if (event instanceof HttpResponse) {
                    // console.log('event');
                    // console.log(event);
                  }
                },
                (err: any) => {
                  // console.log('err');
                  // console.log(err);
                  if (err instanceof HttpErrorResponse) {
                    // console.log(err.status);
                    // console.log('req url :: ' + req.url);
                    if (err.status === 401) {

                      this.router.navigateByUrl('/login');
                    }
                }
              }
                )
            );
        } else {
            this.router.navigateByUrl('/login');
        }
    }
}

